export enum ToolsRequestStatusAction {
  Load = '[Tools] [Request Status] Load',
  Success = '[Tools] [Request Status] Success',
  Error = '[Tools] [Request Status] Error',
}
